import DashboardNavigationBar from '@/components/dashboard/navigation-bar/dashboard-navigation-bar';
import SubNavBar from '@/components/subnav-bar/subnav-bar';
import { ROUTE_DASHBOARD } from '@/constants/routes';
import { Button, IconArrowDown, InlineAlert, Text } from '@cmpsr/components';
import { useNavigate } from 'react-router-dom';
import TestSpecs from '../test-specs/test-specs';
import TestDetailsBody from './components/test-details-body/test-details-body';
import TestDetailsHeader from './components/test-details-header/test-details-header';
import TestDetailsSection from './components/test-details-section/test-details-section';
import useTestDetailsController from './test-details.controller';
import DashboardLayout from '@/components/dashboard/dashboard-layout/dashboard-layout';

export default function TestDetails() {
  const {
    name,
    screeningSpecs,
    why,
    how,
    what,
    insurance,
    cost,
    screeningTypeName,
    icon,
    sectionRefs,
    handleRefsCreated,
    availableNavItems,
    handleDownloadLetter,
    canDownloadLetter,
    isDownloadingLetter,
    isDownloadingLetterError,
    downloadingLetterError,
  } = useTestDetailsController();

  const navigate = useNavigate();

  return (
    <>
      <DashboardNavigationBar activeItem="testing-plan" containerProps={{ zIndex: '3' }} />
      <DashboardLayout containerProps={{ pt: 0 }}>
        <SubNavBar onClick={() => navigate(-1)}>Back</SubNavBar>
        <TestDetailsBody>
          <TestDetailsHeader
            testTitle={name}
            testType={screeningTypeName}
            navItems={availableNavItems}
            icon={icon}
            onRefsCreated={handleRefsCreated}
          />
          {what && what.length > 0 && (
            <TestDetailsSection ref={sectionRefs?.what} icon="test-options" title="About this test" id="what">
              {what}
            </TestDetailsSection>
          )}
          {why && why.length > 0 && (
            <TestDetailsSection
              ref={sectionRefs?.why}
              icon="why-it-matters"
              title="Why should I get this test?"
              id="why"
            >
              {why}
            </TestDetailsSection>
          )}
          {how && (
            <TestDetailsSection
              ref={sectionRefs?.how}
              icon="biomarkers-alt-2"
              title="How to get tested"
              id="how"
              action={
                canDownloadLetter ? (
                  <Button
                    variant="primary-alt"
                    onClick={handleDownloadLetter}
                    trailingIcon={<IconArrowDown />}
                    loadingText="Loading..."
                    isLoading={isDownloadingLetter}
                    size="m"
                    alignSelf="flex-start"
                    border="2px solid"
                  >
                    Download
                  </Button>
                ) : null
              }
            >
              {how}
              {canDownloadLetter ? (
                <Text variant="text-body-regular" mt={4}>
                  Download the attached document to help your doctor understand why you may benefit from a {name}.
                </Text>
              ) : null}
              {canDownloadLetter &&
              isDownloadingLetterError &&
              downloadingLetterError &&
              Object.keys(downloadingLetterError).length > 0 &&
              !isDownloadingLetter ? (
                <InlineAlert status="error" mt="spacer-2">
                  <InlineAlert.Icon />
                  <InlineAlert.Message>Something went wrong. Please try again</InlineAlert.Message>
                </InlineAlert>
              ) : null}
            </TestDetailsSection>
          )}
          <TestDetailsSection ref={sectionRefs?.insurance} icon="insurance" title="Insurance coverage" id="insurance">
            {insurance}
          </TestDetailsSection>
          <TestDetailsSection ref={sectionRefs?.cost} icon="credit-card" title="Out-of-pocket cost" id="cost">
            {cost}
          </TestDetailsSection>

          {screeningSpecs && screeningSpecs.testSensitivity && !isNaN(screeningSpecs.testSensitivity) && (
            <TestSpecs ref={sectionRefs?.value} {...screeningSpecs} id="value" />
          )}

          {/* {alternatives && alternatives.length > 0 && (
            <>
              <Divider mt={{ base: 4, lg: 8 }} mb={4} />
              <Text variant="text-header-M">Alternative screening options</Text>
            </>
          )} */}
        </TestDetailsBody>
      </DashboardLayout>
    </>
  );
}
